async function getQualificationStatus(idNum) {
  return fetch(
    `https://${process.env.REACT_APP_ENV_URL}/api/View_ATKV_KwalifiseerAfslag/check/${idNum}`
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Response is not ok...");
      } else {
        if(response.status === 429)
        {
          throw new Error("MAX REQUESTS REACHED.")
        }
        return response.json();
      }
    })
    .then((data) => {

      return data;
    })
    .catch((err) => {
      throw new Error("Maximum number of requests reached... please try again later.", err);
    });
}

export default getQualificationStatus;